import styles from "./Segmented.module.css";

export interface SegmentOption {
  id: string;
  label: string;
}

interface Props {
  options: SegmentOption[];
  value: string | undefined;
  onChange: (id: string) => void;
  ariaLabel: string;
}

/** iOS-style segmented control: one choice, pressed state on the current segment. */
export function Segmented({ options, value, onChange, ariaLabel }: Props) {
  return (
    <div className={styles.group} role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button key={option.id} type="button" className={styles.segment} aria-pressed={value === option.id} onClick={() => onChange(option.id)}>
          {option.label}
        </button>
      ))}
    </div>
  );
}
